module.exports = __webpack_public_path__ + "static/media/value4.f6d8c093.svg";